// My Products asks for the Fulfilment Location card this way when a product
// is clicked before a location is chosen. The card (when it is on the page)
// scrolls into view, focuses its first tile and is outlined for a moment.
export const SHOW_FULFILMENT_LOCATION = "ship:show-fulfilment-location";

export const showFulfilmentLocation = () =>
  window.dispatchEvent(new Event(SHOW_FULFILMENT_LOCATION));
